import * as req from 'api/actions';
import * as c from './constant';

export const getFeeList = (payload, callback) =>
  req.list(
    c.GET_FEE_LIST,
    '/api/v1/administrators/civil_registries/fees',
    payload,
    callback
  );

export const getSingleFee = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_FEE,
    `/api/v1/administrators/civil_registries/fees/${id}`,
    payload,
    callback
  );

export const createFee = (payload, callback) =>
  req.create(
    c.CREATE_FEE,
    '/api/v1/administrators/civil_registries/fees/',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateFee = (id, payload, callback) =>
  req.update(
    c.UPDATE_FEE,
    `/api/v1/administrators/civil_registries/fees/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeFee = (id, payload, callback) =>
  req.remove(
    c.REMOVE_FEE,
    `/api/v1/administrators/civil_registries/fees/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getPurposeList = (payload, callback) =>
  req.list(
    c.GET_PURPOSE_LIST,
    '/api/v1/administrators/purposes_listing',
    payload,
    callback
  );
